<template>
  <div class="flex items-center h-100" :style="{'direction': $vs.rtl ? 'rtl' : 'ltr'}">
    <edit-icon
      size="1.3x"
      class="hover:text-primary cursor-pointer"
      @click="Edit"
    />
    <trash-2-icon
      size="1.3x"
      class="ml-3 hover:text-primary cursor-pointer"
      @click="Delete"
    />
  </div>
</template>

<script>
import { EditIcon, Trash2Icon } from 'vue-feather-icons'

export default {
  name: 'CellRendererActions',
  components: {
    EditIcon,
    Trash2Icon
  },
  methods: {
    Edit() {
      this.$router.push({name: 'company-admin-template-edit', params: {id: this.params.data.sms_template_uuid } })
    },
    Delete () {
      console.log(this.params.data.sms_template_uuid)
      this.$store.dispatch("smsTemplate/Delete", this.params.data.sms_template_uuid)
        .then(() => {
          this.params.data.refreshData()
          this.ShowSuccessMessage({
            title: 'SMS Deleted',
            text: 'The selected SMS Template was successfully deleted'
          })
        })
      .catch(err => {
        this.ShowErrorMessage({ title: 'Error', text: err })
      })
    },

    ShowSuccessMessage ({ title, text }) {
      this.$vs.notify({
        iconPack: 'feather',
        icon: 'icon-check',
        color: 'success',
        title,
        text
      })
    },
    ShowErrorMessage ({ title, text }) {
      this.$vs.notify({
        iconPack: 'feather',
        icon: 'icon-alert-circle',
        color: 'danger',
        title,
        text
      })
    },
  }
}
</script>
